module.exports = __webpack_public_path__ + "img/france-ligue-1-11.a6eee468.png";